import React from 'react';
import StudentVideo from '../Student/StudentVideo';
import ListeningStatus from '../Global/ListeningStatus';

export default function LipSync ({ onDone, videoURL, speech, word }) {
  return (
    <div className="LipSync">
      <StudentVideo onDone={onDone} onError={onDone} videoURL={videoURL} speech={speech} logToSentry={true}/>
      <div className="videoTitle">
        <span className="keyWord">{word}</span>
      </div>
      <div className="listeningStatusWrapper">
        <ListeningStatus/>
      </div>
    </div>
  );
}